<template>

    <div class="main-bg">
        <Nav></Nav>
        <div class="content">

            <div class="fix-nav" v-show="isfixTab">
                <div class="tabs">
                    <div class="item-tab"
                         v-for="(item, index) in tabs"
                         :key="index"
                         :class="{ active: currentTab === item.id }"
                         @click="tabChange(item.id)"
                         :is-scroll="false">
                        {{ item.name }}
                        <div class="actline" v-if="currentTab === item.id"></div>
                    </div>
                </div>
            </div>
            <template v-if="loading">
                <skeletonVideo></skeletonVideo>
            </template>
            <div class="box" v-else-if="course">

                <div class="nav">
                    <a @click="$router.push({ name: 'home' })">首页</a> /
                    <a @click="$router.push({ name: 'courses' })">在线课程</a> /
                    <a v-if="course"
                       @click="
            $router.push({ name: 'courseDetail', query: { id: course.id } })
          ">{{ course.title }}</a>
                    <p v-if="course">/</p>
                    <span>{{ video.title }}</span>
                </div>

                <div class="course-info">
                    <div class="video-box">
                        <div class="play-box"
                             style="background-size: cover"
                             :style="{ backgroundImage: 'url(' + player.cover + ')' }">
                            <div v-if="checkPlayerStatus" class="des-video">
                                您已打开新视频，暂停本视频播放
                            </div>
                            <div v-if="!playendedStatus">
                                <div class="iframe-player-box"
                                     v-if="isIframe"
                                     v-html="playUrl"></div>
                                <div v-else
                                     class="player-container"
                                     id="player-container"></div>
                            </div>
                            <template  v-else>
                                <div class="alert-message">
                                    <div v-if="playendedStatus">

                                        <template v-if="!isLastpage">
                                            <div class="next-page" @click="goNextVideo(lastVideoid)">
                                                播放下一节课程
                                            </div>
                                            <div class="last-video">
                                                {{ totalTime }}秒后开始自动播放下一节
                                            </div>
                                        </template>
                                        <div class="last-video" v-else>恭喜您已经学完本课程！</div>
                                    </div>


                                </div>

                            </template>
                        </div>
                        <div class="course-chapter-box">
                            <VideoChapterListComp :chapters="chapters"
                                                  :course="course"
                                                  :video="video"
                                                  :videos="videos"
                                                  :isJoin="isJoin"
                                                  v-if="chapters.length > 0"
                                                  @switchVideo="goPlay"></VideoChapterListComp>
                            <VideoListComp :course="course"
                                           :video="video"
                                           :videos="videos[0]"
                                           :isJoin="isJoin"
                                           @switchVideo="goPlay"
                                           v-else></VideoListComp>
                        </div>
                    </div>
                    <div class="tabs" id="NavBar">
                        <div class="item-tab"
                             v-for="(item, index) in tabs"
                             :key="index"
                             :class="{ active: currentTab === item.id }"
                             @click="tabChange(item.id)"
                             :is-scroll="false">
                            {{ item.name }}
                            <div class="actline" v-if="currentTab === item.id"></div>
                        </div>
                    </div>
                </div>
                <div class="course-comments-box" v-show="currentTab === 4">
                    <template>
                        <div v-if="isJoin" class="replybox">
                            <div class="reply">
                                <img class="user-avatar" src="https://exam.chinaopenschool.com:8080/api/app/file…load-file-system/978e39e183324e45ad912f3cc0928549" />
                                <input type="text"
                                       class="reply-input"
                                       placeholder="此处填写你的评论"
                                       v-model="comment.content" />
                                <div class="btn-submit"
                                     :class="{ active: comment.content.length > 0 }"
                                     @click="submitComment">
                                    评论
                                </div>
                            </div>
                        </div>
                    </template>

                    <div class="comment-divider">全部评论</div>
                    <div class="line"></div>

                    <div class="comment-top">
                        <template v-if="comments.length > 0">
                            <div class="comment-item"
                                 v-for="comment in comments"
                                 :key="comment.id">
                                <div class="user-avatar">
                                    <img :src="comment.avatar" />
                                </div>
                                <div class="comment-content">
                                    <div class="comment-info">
                                        <div class="nickname">
                                            {{ comment.userName }}
                                        </div>
                                        <div class="comment-time">
                                            {{ comment.created_at}}
                                        </div>
                                    </div>

                                    <div class="comment-text" v-html="comment.content"></div>
                                </div>
                            </div>
                        </template>
                        <none v-else type="white"></none>
                    </div>
                </div>
                <div v-if="attach" class="attach-list-box" v-show="currentTab === 5">
                    <template v-if="attach.length > 0">
                        <div class="attach-item" v-for="item in attach" :key="item.id">
                            <div class="attach-name">{{ item.name }}</div>
                            <a @click="download(item.id)" class="download-attach">下载附件</a>
                        </div>
                    </template>
                    <none v-else type="white"></none>
                </div>
            </div>


        </div>
        </div>
</template>
<script>
import None from "@/components/training/none.vue";
import VideoListComp from "./components/video/video-list.vue";
import VideoChapterListComp from "./components/video/video-chapter-list.vue";
import SkeletonVideo from "./components/skeletonVideo.vue";
   import Nav from "@/components/nav.vue";
export default {
        components: {
        Nav,
    None,
    VideoListComp,
    VideoChapterListComp,
    SkeletonVideo,
  },
  data() {
    return {
      attach: [],
      videoContext: null,
      loading: false,
        id: this.$route.query.id,
        course: {
            "id": 33,
            "title": "Uni-app实战视频点播小程序",
            "thumb": "http://localhost:8080/img/img_77.3e4914a8.png",
            "charge": 0,
            "short_description": "全网最详细的Uniapp实战开发app小程序课程，7大实战开发案例（社区交友，商城，即时通讯，音频小说、网盘、点播、直播）帮助你获得技术优势并提高面试竞争力。",
            "render_desc": "全网最详细的Uniapp实战开发app小程序课程，7大实战开发案例（社区交友，商城，即时通讯，音频小说、网盘、点播、直播）帮助你获得技术优势并提高面试竞争力",
            "category_id": 4,
            "user_count": 0,
        },
        attach: [],
        chapters: [
            {
                "id": 83,
                "course_id": 33,
                "title": "章节一：准备工作"
            },
            {
                "id": 82,
                "course_id": 33,
                "title": "章节二：项目分析和全局样式"
            },
            {
                "id": 97,
                "course_id": 33,
                "title": "章节三： 首页开发"
            },
            {
                "id": 98,
                "course_id": 33,
                "title": "章节四：后端API开发"
            }
        ],
        videos: {
            "82": [
                {
                    "id": 98,
                    "course_id": 33,
                    "title": "2-1 引入全局样式",
                    "view_num": 0,
                    "chapter_id": 82,
                    "duration": 109,
                },
                {
                    "id": 105,
                    "course_id": 33,
                    "title": "2-2 配置tabbar底部导航",
                    "view_num": 0,
                    "chapter_id": 82,
                    "duration": 109,
                },
                {
                    "id": 109,
                    "course_id": 33,
                    "title": "2-3 引入图标库",
                    "view_num": 0,
                    "chapter_id": 82,
                    "duration": 109,
                }
            ],
            "83": [
                {
                    "id": 97,
                    "course_id": 33,
                    "title": "1-1 环境搭建和项目创建",
                    "view_num": 0,
                    "chapter_id": 83,
                    "duration": 109,
                }
            ],
            "97": [
                {
                    "id": 110,
                    "course_id": 33,
                    "title": "3-1 导航栏配置",
                    "view_num": 0,
                    "chapter_id": 97,
                    "duration": 109,
                },
                {
                    "id": 129,
                    "course_id": 33,
                    "title": "3-2 轮播图组件",
                    "view_num": 0,
                    "chapter_id": 97,
                    "duration": 109,

                },
                {
                    "id": 130,
                    "course_id": 33,
                    "title": "3-3 全局列表组件开发",
                    "view_num": 0,
                    "chapter_id": 97,
                    "duration": 109,

                }
            ],
            "98": [
                {
                    "id": 131,
                    "course_id": 33,
                    "title": "4-1 数据表设计与迁移",
                    "view_num": 0,
                    "chapter_id": 98,
                    "duration": 109,

                },
                {
                    "id": 132,
                    "course_id": 33,
                    "title": "4-2 前后端数据交互",
                    "view_num": 0,
                    "chapter_id": 98,
                    "duration": 109,

                }
            ]
        },
        video: {
            "id": 97,
            "course_id": 33,
            "title": "1-1 环境搭建和项目创建",
            "view_num": 0,  
            "chapter_id": 83,
            "duration": 109,
            "ban_drag": 1,
        },
       
      isWatch: false,
      currentTab: 4,
      playUrl: "",
      nowTime: Date.parse(new Date()) / 1000,
        
      tabs: [
        {
          name: "课时评论",
          id: 4,
        },
        {
          name: "课程附件",
          id: 5,
        },
      ],
        comments: [
            {
                "id": 39,
                "userName": "管理员",
                "avatar": "https://exam.chinaopenschool.com:8080//api/app/file/download-file-system/978e39e183324e45ad912f3cc0928549",
                "content": "测试测试模拟评论",
                "created_at": "2023-10-31 13:38:23"
            }
        ],
      comment: {
        content: "",
      },
      totalTime: 10,
        video_watched_progress: {
            "97": {
                "id": 507,
                "course_id": 33,
                "video_id": 97,
                "watch_seconds": 109
            },
            "98": {
                "id": 508,
                "course_id": 33,
                "video_id": 98,
                "watch_seconds": 109,
            }
        },
      isLastpage: false,
      lastVideoid: null,
      playendedStatus: false,
      playDuration: 0,
      isfixTab: false,
      isIframe: false, //第三方课件嵌套播放
      isJoin: true,
      last_see_value: null,
      clock: null,
      checkPlayerStatus: false,
        timer: null,
        player: {
            "cover": "http://localhost:8080/img/img_77.3e4914a8.png",
            "enabled_bullet_secret": "1",
            "bullet_secret": {
                "size": "14",
                "color": "#CCCCCC",
                "opacity": "1",
                "text": "newv"
            }
        },
    };
  },
  watch: {
    $route(to, from) {
      this.$router.go(0);
    },
  },
  computed: {
  },
  mounted() {
    window.addEventListener("scroll", this.handleTabFix, true);
    this.getDetail();
    this.getComments();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleTabFix, true);
    // 播放器销毁
    window.player && window.player.destroy();
    this.clock && window.clearInterval(this.clock);
    window.clearInterval(this.timer);
  },
  methods: {
    checkVisibility() {
      if (window.player) {
        window.player.pause();
      }
    },

    handleTabFix() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let navbar = document.querySelector("#NavBar");
      if (navbar) {
        let offsetTop = navbar.offsetTop;
        scrollTop > offsetTop
          ? (this.isfixTab = true)
          : (this.isfixTab = false);
      }
    },
    tabChange(key) {
      this.currentTab = key;
    },

      goPlay(item) {
         
          this.last_see_value = null;
          this.$router.push({
              name: "courseVideo",
              query: {
                  id: item.id,
              },
          });
      },
    goNextVideo(id) {
      this.last_see_value = null;
      this.$router.push({
          name: "courseVideo",
        query: {
          id: id,
        },
      });
    },
   //附件下载材料
    getAttach() {
      //Api.Detail(this.course.id).then((res) => {
      //  this.attach = res.data.attach;
      //});
    },
    getDetail() {
      if (this.loading) {
        return;
      }
        this.loading = true;
        let chapteId = parseInt(this.video.chapter_id) || 0;

        // 视频排序数组
        let videoBox = [];
        if (chapteId === 0) {
            videoBox = this.videos[chapteId];
        } else {
            for (var k = 0; k < this.chapters.length; k++) {
                let chap = parseInt(this.chapters[k].id);
                if (typeof this.videos[chap] !== "undefined") {
                    videoBox.push(...this.videos[chap]);
                }
            }
        }

        // 读取下一个视频
        for (var j = 0; j < videoBox.length; j++) {
            if (this.video.id === videoBox[j].id) {
                if (1 + j >= videoBox.length) {
                    this.isLastpage = true;
                } else {
                    this.lastVideoid = videoBox[j + 1].id;
                }
            }
        }

        // 自动锁定当前视频位置
        this.$nextTick(() => {
            setTimeout(() => {
                if (this.chapters.length > 0) {
                    let pos = document.querySelector(".selChapter").offsetTop - 289;
                    if (pos > 0) {
                        document.querySelector(".course-chapter-box").scrollTop = pos;
                    }
                }
            }, 200);
        });

        // 播放视频
        this.getPlayInfo();


        //获取附件
        this.getAttach();


        //播放记录跳转
        if (
            this.video_watched_progress &&
            this.video_watched_progress[this.video.id] &&
            this.video_watched_progress[this.video.id].watch_seconds > 0
        ) {
            this.last_see_value = {
                time: 5, //提示时间 5秒后关闭提示
                pos: this.video_watched_progress[this.video.id].watch_seconds,  //提示上次观看位置
            };
        }
        this.loading = false;
        //Api.Video(this.id)
        //.then((res) => {
        //  this.loading = false;
        //  this.video = res.data.video;
        //  this.course = res.data.course;
        //  this.videos = res.data.videos;
        //  this.isWatch = res.data.is_watch;
        //  this.chapters = res.data.chapters;
        //  this.video_watched_progress = res.data.video_watched_progress;
        //  document.title = res.data.course.title;
        //  let chapteId = parseInt(res.data.video.chapter_id) || 0;

        //  // 视频排序数组
        //  let videoBox = [];
        //  if (chapteId === 0) {
        //    videoBox = res.data.videos[chapteId];
        //  } else {
        //    for (var k = 0; k < this.chapters.length; k++) {
        //      let chap = parseInt(this.chapters[k].id);
        //      if (typeof res.data.videos[chap] !== "undefined") {
        //        videoBox.push(...res.data.videos[chap]);
        //      }
        //    }
        //  }

        //  // 读取下一个视频
        //  for (var j = 0; j < videoBox.length; j++) {
        //    if (res.data.video.id === videoBox[j].id) {
        //      if (1 + j >= videoBox.length) {
        //        this.isLastpage = true;
        //      } else {
        //        this.lastVideoid = videoBox[j + 1].id;
        //      }
        //    }
        //  }

        //  // 自动锁定当前视频位置
        //  this.$nextTick(() => {
        //    setTimeout(() => {
        //      if (this.chapters.length > 0) {
        //        let pos = document.querySelector(".selChapter").offsetTop - 289;
        //        if (pos > 0) {
        //          document.querySelector(".course-chapter-box").scrollTop = pos;
        //        }
        //      }
        //    }, 200);
        //  });

        //  // 播放视频
        //    this.getPlayInfo();
        

        //  //获取附件
        //  this.getAttach();


        //  //播放记录跳转
        //  if (
        //    this.video_watched_progress &&
        //    this.video_watched_progress[this.video.id] &&
        //    this.video_watched_progress[this.video.id].watch_seconds > 0
        //  ) {
        //    this.last_see_value = {
        //      time: 5,
        //      pos: this.video_watched_progress[this.video.id].watch_seconds,
        //    };
        //  }
        //})
        //.catch((e) => {
        //  this.loading = false;
        //  this.$message.error(e.message);
        //});
    },
    getPlayInfo() {

        let playUrls = [
            {
                "url": "https://mooc1vod.stu.126.net/nos/mp4/2016/12/30/1005642049_1da2581009c54bdab39ab1f5879c8c8d_sd.mp4?ak=7909bff134372bffca53cdc2c17adc27a4c38c6336120510aea1ae1790819de8bbbcbeb725be901d86a7bec1905394cba772d0d09cbb6dec0ad9a557cf3190a83059f726dc7bb86b92adbc3d5b34b132a933b6d3edde1c31b8d3111e77c3dd3cb108680c195ae7aedbefcbd824e55924",
       
            }
        ];
           let firstPlayUrl = playUrls[0].url;

          if (firstPlayUrl.substr(1, 6) === "iframe") {
            this.isIframe = true;
            this.playUrl = firstPlayUrl.replace(
              ">",
              ' style="width:100%;height:506px" >'
            );
            return;
          }
        this.initDPlayer(playUrls);
        //Api.PlayInfo(this.video.id)
        //.then((res) => {
        //  if (res.data.urls.length === 0) {
        //    this.$message.error("无播放地址");
        //    return;
        //  }

        //  let playUrls = res.data.urls;
        //  let firstPlayUrl = playUrls[0].url;

        //  if (firstPlayUrl.substr(1, 6) === "iframe") {
        //    this.isIframe = true;
        //    this.playUrl = firstPlayUrl.replace(
        //      ">",
        //      ' style="width:100%;height:506px" >'
        //    );
        //    return;
        //  }

        //  this.initDPlayer(playUrls, isTrySee);
        //})
        //.catch((e) => {
        //  this.$message.error(e.message);
        //});
    },
    initDPlayer(playUrls) {
      // 封装DPlayer的播放格式
      let dplayerUrls = [];
      playUrls.forEach((item) => {
        dplayerUrls.push({
          name: "",
          url: item.url,
        });
      });

      // 初始化播放器
      let bulletSecretFontSize = !this.player.bullet_secret.size
        ? 14
        : this.player.bullet_secret.size;
      window.player = new window.DPlayer({
        container: document.getElementById("player-container"),
        autoplay: false, 
        video: {  //视频文件
          quality: dplayerUrls,
          defaultQuality: 0,
          pic: this.player.cover,
        },
        try: false,
          bulletSecret: { //跑马灯
          enabled: parseInt(this.player.enabled_bullet_secret) === 1,
              text: this.player.bullet_secret.text,
          size: bulletSecretFontSize + "px",
          color: !this.player.bullet_secret.color
            ? "red"
            : this.player.bullet_secret.color,
          opacity: this.player.bullet_secret.opacity,
        },
        ban_drag: parseInt(this.video.ban_drag) === 1,   //进度条拖动
        last_see_pos: this.last_see_value,  //提示上次观看到的位置
      });

      // 监听播放进度更新evt
      window.player.on("timeupdate", () => {
        this.playTimeUpdate(parseInt(window.player.video.currentTime));
      });
      window.player.on("ended", () => {
        this.playTimeUpdate(parseInt(window.player.video.currentTime), true);
        this.playendedStatus = true;
        this.totalTime = 10;
        this.$nextTick(function() {
          if (!this.isLastpage) {
            this.countDown();
          }
        });
        window.player.destroy();
      });
    
        //存储当前播放视频id
       this.savePlayId(this.video.id);
      this.checkPlayer();
    },
    checkPlayer() {
      this.timer = window.setInterval(() => {
        let playId = this.getPlayId();
        if (parseInt(playId) !== this.video.id) {
          window.player.destroy();
          this.checkPlayerStatus = true;
        } else {
          this.checkPlayerStatus = false;
        }
      }, 5000);
    },
    countDown() {
      this.clock = window.setInterval(() => {
        this.totalTime--;
        if (this.totalTime === 0) {
          window.clearInterval(this.clock);
          this.goNextVideo(this.lastVideoid);
        }
      }, 1000);
    },
    getComments() {
        //Api.VideoComments(this.id)
        //.then((res) => {
        //  this.comments = res.data.comments;
        //})
        //.catch((e) => {
        //  this.$message.error(e.message);
        //});
    },
    playUpdate(e) {
      let duration = e.detail.currentTime;
      this.playTimeUpdate(duration);
    },
      playTimeUpdate(duration, isEnd) {
        //保存学习进度  每隔一分钟自动保存
      if (duration - this.playDuration >= 60 || isEnd === true) {
        this.playDuration = duration;
        //  Api.VideoRecord(this.video.id, {
        //  duration: this.playDuration,
        //}).then(() => {
          // todo
        /*});*/
      }
    },
    resetComments() {
      this.comment.content = "";
      this.comments = [];
    },
    download(id) {
   
    
      },
    //评价
    submitComment() {
      if (this.comment.content.length === 0) {
        return;
      }
        //Api.SubmitVideoComment(this.id, this.comment)
        //.then(() => {
        //  this.$message.success("成功");
        //  this.resetComments();
        //  this.getComments();
        //})
        //.catch((e) => {
        //  this.$message.error(e.message);
        //});
      },
      savePlayId(id) {
          window.localStorage.setItem("palyId", id);
      },
      getPlayId() {
          return window.localStorage.getItem("palyId");
      },
  },
};
</script>
<style lang="scss" scoped>
    .main-bg {
        background-image: url("../../../assets/home/backougnd.png");
        background-size: cover;
        overflow-x: hidden;

        .content {
            width: 100%;
            padding-top: 86px;

            .fix-nav {
                width: 100%;
                background-color: #fff;
                position: sticky;
                top: 0;
                z-index: 50;

                .tabs {
                    width: 1200px;
                    margin: 0 auto;
                    height: 72px;
                    position: relative;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: row;
                    padding: 28px 30px;
                    border-radius: 0px 0px 8px 8px;

                    .item-tab {
                        min-width: 64px;
                        height: 16px;
                        font-size: 16px;
                        font-weight: 400;
                        color: #666666;
                        line-height: 16px;
                        margin-right: 80px;
                        cursor: pointer;
                        position: relative;

                        &.active {
                            font-weight: 600;
                            color: #3ca7fa;
                        }

                        .actline {
                            width: 52px;
                            height: 4px;
                            background: #3ca7fa;
                            position: absolute;
                            left: 6px;
                            top: 40px;
                        }
                    }
                }
            }

            .box {
                width: 1200px;
                margin: 0 auto;

                .nav {
                    width: 100%;
                    height: auto;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    align-items: center;
                    font-size: 14px;
                    color: #999999;
                    line-height: 14px;
                    margin-top: 30px;
                    margin-bottom: 30px;

                    a {
                        height: auto;
                        font-size: 14px;
                        font-weight: 400;
                        color: #999999;
                        line-height: 14px;
                        margin-right: 6px;
                        cursor: pointer;

                        &:not(:first-of-type) {
                            margin-left: 6px;
                        }
                    }

                    span {
                        flex: 1;
                        height: auto;
                        margin-left: 6px;
                        font-size: 14px;
                        font-weight: 400;
                        color: #666666;
                        line-height: 14px;
                        display: block;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }

                .course-info {
                    width: 1200px;
                    height: 578px;
                    background: #ffffff;
                    border-radius: 8px;

                    .video-box {
                        width: 1200px;
                        height: 506px;
                        display: flex;
                        flex-direction: row;

                        .play-box {
                            width: 900px;
                            height: 506px;
                            position: relative;

                            .des-video {
                                position: absolute;
                                left: 350px;
                                top: 216px;
                                font-size: 15px;
                                font-weight: 400;
                                color: #ffffff;
                                line-height: 15px;
                            }

                            .goCurrent {
                                position: absolute;
                                z-index: 2003;
                                width: auto;
                                height: auto;
                                background: rgba(0, 0, 0, 0.6);
                                border-radius: 0px 4px 4px 0px;
                                left: 0;
                                bottom: 50px;
                                display: flex;
                                flex-direction: row;
                                padding: 15px 20px;

                                span {
                                    font-size: 16px;
                                    font-weight: 400;
                                    color: #ffffff;
                                    line-height: 22px;

                                    &.link {
                                        cursor: pointer;
                                        color: #3ca7fa;
                                        margin-left: 10px;
                                    }
                                }
                            }

                            .iframe-player-box {
                                width: 100%;
                                height: 100%;
                            }

                            .alert-message {
                                width: 100%;
                                height: 100%;
                                background: rgba(0, 0, 0, 0.6);
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;
                                font-size: 14px;
                                color: white;

                                .subscribe-button {
                                    box-sizing: border-box;
                                    margin: 0 auto;
                                    width: 200px;
                                    padding: 15px 20px;
                                    text-align: center;
                                    font-size: 15px;
                                    font-weight: 400;
                                    border-radius: 4px;
                                    background-color: #ff4d4f;
                                    color: white;
                                    cursor: pointer;
                                }

                                .subscribe-button2 {
                                    margin-top: 30px;
                                    font-size: 15px;
                                    font-weight: 400;
                                    color: #ff4d4f;
                                    line-height: 15px;
                                    cursor: pointer;
                                }

                                .subscribe-info {
                                    margin-top: -30px;
                                    margin-bottom: 30px;
                                }

                                .next-page {
                                    box-sizing: border-box;
                                    margin: 0 auto;
                                    width: 152px;
                                    height: auto;
                                    padding: 10px 20px;
                                    margin-bottom: 20px;
                                    background: #3ca7fa;
                                    color: white;
                                    border-radius: 4px;
                                    cursor: pointer;
                                    text-align: center;

                                    &:hover {
                                        opacity: 0.8;
                                    }
                                }

                                .last-video {
                                    font-size: 15px;
                                    font-weight: 400;
                                    color: #ffffff;
                                    line-height: 15px;
                                }
                            }
                        }

                        .course-chapter-box {
                            width: 300px;
                            height: 506px;
                            padding: 30px 10px 30px 30px;
                            background: #ffffff;
                            overflow-y: auto;
                        }
                    }

                    .course-info-box {
                        width: 1200px;
                        height: 300px;
                        box-sizing: border-box;
                        padding: 30px 50px 30px 30px;
                        position: relative;
                        display: flex;
                        flex-direction: row;

                        .course-thumb {
                            width: 320px;
                            height: 240px;
                            border-radius: 8px;
                            margin-right: 50px;
                            position: relative;

                            img {
                                width: 320px;
                                height: 240px;
                                border-radius: 8px;
                            }

                            .status {
                                position: absolute;
                                top: 10px;
                                left: 10px;
                                background-color: rgba(60, 167, 250);
                                color: #fff;
                                font-size: 14px;
                                padding: 4px;
                                border-radius: 4px;
                            }
                        }

                        .info {
                            width: 750px;
                            height: 240px;
                            position: relative;

                            .course-info-title {
                                width: 710px;
                                height: 24px;
                                font-size: 24px;
                                font-weight: 500;
                                color: #333333;
                                line-height: 24px;
                                margin-top: 20px;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }

                            .collect-button {
                                width: 29px;
                                height: 29px;
                                position: absolute;
                                right: 0;
                                top: 15px;
                                cursor: pointer;
                            }

                            .desc {
                                margin-top: 20px;
                                width: 750px;
                                height: 120px;
                                font-size: 16px;
                                font-weight: 400;
                                color: #666666;
                                line-height: 30px;
                                overflow: hidden;
                            }
                        }
                    }

                    .tabs {
                        width: 1200px;
                        height: 72px;
                        position: relative;
                        box-sizing: border-box;
                        display: flex;
                        flex-direction: row;
                        padding: 28px 30px;
                        border-radius: 0px 0px 8px 8px;

                        .item-tab {
                            min-width: 64px;
                            height: 16px;
                            font-size: 16px;
                            font-weight: 400;
                            color: #666666;
                            line-height: 16px;
                            margin-right: 80px;
                            cursor: pointer;
                            position: relative;

                            &.active {
                                font-weight: 600;
                                color: #3ca7fa;
                            }

                            .actline {
                                width: 52px;
                                height: 4px;
                                background: #3ca7fa;
                                position: absolute;
                                left: 6px;
                                top: 40px;
                            }
                        }
                    }
                }

                .course-teacher-box {
                    width: 1200px;
                    height: 270px;
                    background: #ffffff;
                    border-radius: 8px;
                    margin-top: 30px;
                    padding: 30px 50px;
                    box-sizing: border-box;

                    .teacher {
                        width: auto;
                        height: 80px;
                        display: flex;
                        align-items: center;
                        flex-direction: row;

                        .avatar {
                            width: 80px;
                            height: 80px;
                            border-radius: 50%;
                            margin-right: 20px;
                        }

                        a {
                            width: 100%;
                            height: 24px;
                            font-size: 24px;
                            font-weight: 600;
                            color: #333333;
                            line-height: 24px;
                        }
                    }

                    .teacher-desc {
                        margin-top: 26px;
                        width: 100%;
                        height: 64px;
                        font-size: 16px;
                        font-weight: 400;
                        color: #666666;
                        line-height: 32px;
                        overflow: hidden;
                    }
                }

                .coursr-desc {
                    padding: 30px;
                    background: #ffffff;
                    margin: 30px 0px;
                    border-radius: 8px;
                }

                .course-comments-box {
                    width: 1200px;
                    box-sizing: border-box;
                    background: #ffffff;
                    margin: 30px 0px;
                    border-radius: 8px;
                    padding: 50px 30px 30px 30px;

                    .comment-divider {
                        width: 100%;
                        height: 18px;
                        font-size: 18px;
                        font-weight: 600;
                        color: #333333;
                        line-height: 18px;
                    }

                    .line {
                        width: 100%;
                        height: 1px;
                        background: #e5e5e5;
                        margin: 30px 0px;
                    }

                    .comment-top {
                        box-sizing: border-box;
                        width: 100%;
                        padding: 0px 0px 0px 0px;
                        display: flex;
                        flex-direction: column;

                        #page {
                            width: 100%;
                            display: flex;
                            justify-content: center;
                        }

                        .comment-item {
                            width: 100%;
                            display: flex;
                            flex-direction: row;
                            margin-bottom: 50px;

                            &:last-child {
                                margin-bottom: 0px;
                            }

                            .user-avatar {
                                width: 48px;
                                height: 48px;
                                background: #d8d8d8;
                                border-radius: 50%;
                                margin-right: 30px;

                                img {
                                    width: 48px;
                                    height: 48px;
                                    border-radius: 50%;
                                }
                            }

                            .comment-content {
                                width: 1062px;
                                display: flex;
                                flex-direction: column;

                                .comment-info {
                                    margin-top: 3px;
                                    display: flex;
                                    flex-direction: row;
                                    height: 14px;
                                    font-size: 14px;
                                    font-weight: 400;
                                    color: #666666;
                                    line-height: 14px;
                                    margin-bottom: 16px;

                                    .nickname {
                                        margin-right: 15px;
                                    }
                                }

                                .comment-text {
                                    width: 1062px;
                                    font-size: 14px;
                                    font-weight: 400;
                                    color: #333333;
                                    line-height: 20px;
                                    display: flex;
                                    flex-direction: row;
                                    flex-wrap: wrap;
                                }
                            }
                        }
                    }

                    .replybox {
                        box-sizing: border-box;
                        width: 100%;
                        height: 48px;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        margin-bottom: 50px;

                        .text {
                            width: 100%;
                            text-align: center;
                            cursor: pointer;

                            &:hover {
                                color: #3ca7fa;
                                text-decoration: underline;
                            }
                        }

                        .reply {
                            width: 100%;
                            display: flex;
                            flex-direction: row;
                            align-items: center;

                            .user-avatar {
                                width: 48px;
                                height: 48px;
                                background: #d8d8d8;
                                border-radius: 50%;
                                margin-right: 30px;
                            }

                            .reply-input {
                                width: 960px;
                                height: 48px;
                                border-radius: 4px;
                                border: 1px solid #cccccc;
                                padding-left: 10px;
                                margin-right: 30px;
                                outline: none;
                            }

                            .btn-submit {
                                width: 72px;
                                height: 48px;
                                background: #cccccc;
                                border-radius: 4px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 16px;
                                font-weight: 400;
                                color: #ffffff;
                                line-height: 16px;
                                cursor: pointer;

                                &:hover {
                                    opacity: 0.8;
                                }

                                &.active {
                                    background: #3ca7fa;
                                }
                            }
                        }
                    }
                }

                .attach-list-box {
                    width: 1200px;
                    display: flex;
                    flex-direction: column;
                    box-sizing: border-box;
                    padding: 50px 30px;
                    background: #ffffff;
                    margin-top: 30px;
                    border-radius: 8px;

                    .attach-item {
                        width: 100%;
                        box-sizing: border-box;
                        height: 40px;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        margin-top: 50px;

                        &:first-child {
                            margin-top: 0px;
                        }

                        .attach-name {
                            height: 16px;
                            font-size: 16px;
                            font-weight: 500;
                            color: #333333;
                            line-height: 16px;
                        }

                        .download-attach {
                            margin-left: 30px;
                            width: 104px;
                            height: 40px;
                            background: #3ca7fa;
                            border-radius: 4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 16px;
                            font-weight: 400;
                            color: #ffffff;
                            cursor: pointer;

                            &:hover {
                                opacity: 0.8;
                            }
                        }
                    }
                }
            }
        }

        #player-container {
            width: 900px;
            height: 506px;
            float: left;
        }

        ::-webkit-scrollbar {
            width: 8px;
            height: 8px;
        }

        ::-webkit-scrollbar-thumb {
            border-radius: 5px;
            background-color: #e5e5e5;
        }

        ::-webkit-scrollbar-track {
            background: #fff;
            border-radius: 0px;
        }
    }
</style>
